import { useEffect, useState } from 'react'

import { FilterManager } from '../../../../common/filter/FilterManager'
import { getMerchantLookupWithToken } from '../../../../common/core/_requests'
import { getPaymentMethods } from '../../../settings/api/getPaymentMethods'
import { MatchingFinishedPayoutFilterState } from '../../core/_models'
import { statusFilterOptions } from './config'

type Option = { value: string; label: string }

interface Props {
  /** Начальные значения формы (на первом рендере — из URL). Оно же — цель «Сбросить». */
  defaultValues: MatchingFinishedPayoutFilterState
  onApplyFilters: (filters: MatchingFinishedPayoutFilterState) => void
}

const dateModes = [
  { value: 'created', label: 'По дате создания' },
  { value: 'completed', label: 'По дате закрытия' },
]

const FinishedPayoutTicketsFilter = ({ defaultValues, onApplyFilters }: Props) => {
  const [merchantOptions, setMerchantOptions] = useState<Option[]>([])
  const [paymentOptions, setPaymentOptions] = useState<Option[]>([])

  useEffect(() => {
    let cancelled = false

    // lookup-with-token доступен всем ролям раздела, включая ROLE_MATCHING_OPERATOR
    // (в отличие от getListMerchantsForSelect, который для оператора уходит на публичный
    // /api/merchant/list). value = токен мерчанта, label = название.
    getMerchantLookupWithToken()
      .then((resp) => {
        if (cancelled || !resp.data?.success) return
        setMerchantOptions(resp.data.data ?? [])
      })
      .catch(() => setMerchantOptions([]))

    getPaymentMethods()
      .then((resp: any) => {
        if (cancelled || !resp?.data?.success) return
        const list = resp.data.paymentMethods ?? []
        setPaymentOptions(list.map((pm: any) => ({ value: pm.type, label: pm.type })))
      })
      .catch(() => setPaymentOptions([]))

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <FilterManager<MatchingFinishedPayoutFilterState>
      activeFilters={[
        'search',
        'dateRange',
        { filter: 'selectMulti', fieldName: 'statusList' },
        { filter: 'selectMulti', fieldName: 'merchantTokenList' },
        { filter: 'selectMulti', fieldName: 'paymentMethodList' },
      ]}
      defaultValues={defaultValues}
      filterProps={{
        search: { label: 'Поиск', placeholder: 'ID тикета или ID транзакции' },
        dateRange: { modes: dateModes, ranges: [] },
        statusList: { label: 'Статус', options: statusFilterOptions, placeholder: 'Все' },
        merchantTokenList: { label: 'Мерчант', options: merchantOptions, placeholder: 'Все' },
        paymentMethodList: {
          label: 'Платёжный метод',
          options: paymentOptions,
          placeholder: 'Все',
        },
      }}
      onApplyFilters={onApplyFilters}
    />
  )
}

export default FinishedPayoutTicketsFilter
